import React, { Component } from 'react'
import { Col, Container, Row } from '../../../Shared/Grid'
import Input from '../../../Shared/Form/Input'
import { getCountries, getPropertyAddress } from '../../../../api'
import CountrySelect from '../../../Shared/Form/CountrySelect'
import Button from '../../../Shared/Form/Button'
import isEmpty from 'lodash.isempty'

import './styles.scss'

import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Alert from '../../Alert'
import WinlineId from './winlineId'
import SalesTokenInput from '../../Order/SalesTokenInput'
import { connect } from 'react-redux'
import { setToken } from '../../../../redux/actions/salesToken'

const nullable = {
  state: 1,
  url: 1,
  fax: 1,
  vatId: 1,
  winlineId: 1
}

const defaultCustomer = {
  company: '',
  legalForm: '',
  firstname: '',
  lastname: '',
  street: '',
  zip: '',
  city: '',
  state: '',
  countryCode: '',
  email: '',
  url: '',
  phone: '',
  fax: '',
  vatId: '',
  winlineId: ''
}

class CustomerEdit extends Component {

  constructor (props) {
    super(props)
    this.state = {
      customer: Object.assign({}, defaultCustomer),
      initialized: false,
      loading: false,
      countries: [],
      errors: {},
      salesToken: this.props.isAdminUI ? null : {
        value: props.salesToken.token,
        valid: !props.salesToken.token ? false : undefined
      },
      numberOfRooms: this.props.isAdminUI ? null : this.props.cart.items[0]?.payload.numberOfRooms
    }
  }

  componentDidMount () {
    this.setState({ loading: true }, async () => {
      try {
        const countries = await getCountries()
        const customer = this.props.customer
        await this.setCustomer(customer)
        this.setState({
          countries: countries,
          initialized: true
        })
      } catch (e) {
        this.setState({ error: 'Failed to get countries' })
        console.log(e)
      }
    })
  }

  shouldPrefill () {
    return !(this.props.prefill !== true || !this.props.cart?.items[0]?.id)
  }

  async setCustomer (customer) {
    if (!customer) {
      const prefilledCustomer = Object.assign({}, defaultCustomer)
      if (this.shouldPrefill() === true) {
        const propertyAddress = await getPropertyAddress(this.props.cart.items[0].id)
        const streetAndStreetNumber = []
        if (propertyAddress.address.street !== null) {
          streetAndStreetNumber.push(propertyAddress.address.street)
        }
        if (propertyAddress.address.street !== null) {
          streetAndStreetNumber.push(propertyAddress.address.streetNumber)
        }
        prefilledCustomer.company = this.props.cart.items[0]?.payload?.name ?? ''
        prefilledCustomer.street = streetAndStreetNumber.length > 0 ? streetAndStreetNumber.join(' ') : ''
        prefilledCustomer.zip = propertyAddress.address.zip ?? ''
        prefilledCustomer.city = propertyAddress.address.city ?? ''
        prefilledCustomer.state = propertyAddress.address.state ?? ''
        prefilledCustomer.countryCode = propertyAddress.address.country ?? ''
      }
      this.setState({
        customer: Object.assign({}, prefilledCustomer),
      })
      return
    }
    customer = Object.assign({}, customer)

    Object.keys(nullable).forEach((key) => {
      if (customer[key] === null) {
        customer[key] = ''
      }
    })
    this.setState({ customer })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.customer !== this.props.customer) {
      this.setCustomer(this.props.customer)
    }
    if (prevProps.salesToken !== this.props.salesToken) {
      const valid = this.props.salesToken.token === this.state.salesToken.value ? this.state.salesToken.valid : undefined
      this.setState({ salesToken: { value: this.props.salesToken.token, valid: valid } })
    }
  }

  updateCustomer (fieldName, value) {
    const customer = { ...this.state.customer }
    customer[fieldName] = value
    this.setState({ customer: customer })
  }

  handleSubmit (e) {
    e.preventDefault()
    if (this.isFormOk() === true) {
      let customer = Object.assign({}, this.state.customer)
      Object.keys(nullable).forEach((key) => {
        if (customer[key] === '') {
          customer[key] = null
        }
      })
      this.props.onSave(customer)
    }
  }

  isFormOk () {
    const { t } = this.props
    const errors = {}
    const requiredFields = [
      'company', 'legalForm', 'firstname', 'lastname', 'street', 'zip', 'city',
      'countryCode', 'email', 'phone'
    ]
    for (const requiredField of requiredFields) {
      if (this.state.customer[requiredField] === '') {
        errors[requiredField] = t('FORM_FIELD_IS_REQUIRED')
      }
    }
    if (this.state.customer.email !== '' && this.isEmailValid(this.state.customer.email) === false) {
      errors['email'] = t('FORM_FIELD_IS_INVALID')
    }
    if (this.selectedCountryIsEuMemberButNotDE() === true && this.state.customer.vatId === '') {
      errors['vatId'] = t('FORM_FIELD_IS_REQUIRED')
    }
    this.setState({ errors: errors })
    return isEmpty(errors)
  }

  isEmailValid (email) {
    return /^[^@]+?@(?:[^@.]+\.)+[^@.]{2,}?$/.test(email)
  }

  selectedCountryIsEuMemberButNotDE () {
    if (this.state.customer.countryCode !== '' && this.state.countries[this.state.customer.countryCode]) {
      return this.state.countries[this.state.customer.countryCode].isMemberOfEU && this.state.customer.countryCode !== 'DE'
    }
    return false
  }

  getCustomerValue (field) {
    if (this.state.customer[field] === null && nullable.hasOwnProperty(field)) {
      return ''
    }
    return this.state.customer[field]
  }

  onSalesTokenValidated = (isValid, token) => {
    if (this.state.salesToken.valid !== isValid || this.state.salesToken.value !== token) {
      this.setState({
        salesToken: {
          value: token,
          valid: isValid
        }
      }, () => {
        if (this.state.salesToken.valid) {
          this.props.setToken(this.state.salesToken.value)
        } else if (this.state.salesToken.value === '') {
          this.props.setToken(null)
        }
      })
    }
  }

  render () {
    const { t } = this.props
    if (this.state.error) {
      return <Alert type={'danger'}>{this.state.error}</Alert>
    }
    if (!this.state.initialized) {
      return null
    }
    return (
      <form className={'edit-form'} onSubmit={(event) => this.handleSubmit(event)}>
        <Container className={'container'} fluid gutterWidth={30}>
          {!this.props.isAdminUI &&
            <div className={'container-part'}>
              <Row className={'container-row'}>
                <Col xs={6}>
                  <SalesTokenInput
                    token={this.state.salesToken.value}
                    onValidated={this.onSalesTokenValidated}
                    label={t('APPLY_PROMOTION_CODE')}
                    round={true}
                  />
                </Col>
                <Col xs={6}>
                  <Input
                    disabled={true}
                    value={this.state.numberOfRooms}
                    label={t('NUMBER_OF_ROOMS')}
                    onChange={() => {}}
                    round={true}
                    alignRight={true}
                    tooltip={t('NUMBER_OF_ROOMS_TOOLTIP')}
                  />
                </Col>
              </Row>
            </div>
          }
          <div className={'container-part'}>
            <div className={'container-part-title'}>
              <span className={'weighted-text'}>{t('CONTAINER_PART_TITLE_ONE')}</span>
            </div>
            <Row className={'container-row'}>
              <Col xs={6}>
                <Input value={this.getCustomerValue('firstname')} label={t('FIRST_NAME')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('firstname')}
                       message={this.state.errors.firstname ? this.state.errors.firstname : ''}
                       onChange={(event) => this.updateCustomer('firstname', event.target.value)}
                       round={true}
                />
              </Col>
              <Col xs={6}>
                <Input value={this.getCustomerValue('lastname')} label={t('LAST_NAME')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('lastname')}
                       message={this.state.errors.lastname ? this.state.errors.lastname : ''}
                       onChange={(event) => this.updateCustomer('lastname', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={6}>
                <Input value={this.getCustomerValue('email')}
                       type={'email'}
                       label={t('EMAIL')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('email')}
                       message={this.state.errors.email ? this.state.errors.email : ''}
                       onChange={(event) => this.updateCustomer('email', event.target.value)}
                       round={true}
                />
              </Col>
              <Col xs={6}>
                <Input value={this.getCustomerValue('legalForm')} label={t('LEGAL_FORM')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('legalForm')}
                       message={this.state.errors.legalForm ? this.state.errors.legalForm : ''}
                       onChange={(event) => this.updateCustomer('legalForm', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={12}>
                <Input value={this.getCustomerValue('phone')} label={t('PHONE')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('phone')}
                       message={this.state.errors.phone ? this.state.errors.phone : ''}
                       onChange={(event) => this.updateCustomer('phone', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={12}>
                <Input value={this.getCustomerValue('company')} label={t('COMPANY')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('company')}
                       message={this.state.errors.company ? this.state.errors.company : ''}
                       onChange={(event) => this.updateCustomer('company', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={12}>
                <Input value={this.getCustomerValue('street')} label={t('STREET_STREET_NUMBER')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('street')}
                       message={this.state.errors.street ? this.state.errors.street : ''}
                       onChange={(event) => this.updateCustomer('street', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={6}>
                <CountrySelect countries={this.state.countries}
                               selected={this.getCustomerValue('countryCode')}
                               onChange={(event) => this.updateCustomer('countryCode', event.target.value)}
                               language={this.props.i18n.language}
                               required={true}
                               valid={!this.state.errors.hasOwnProperty('countryCode')}
                               round={true}
                               message={this.state.errors.countryCode ? this.state.errors.countryCode : ''}
                               placeholder={t('PLACEHOLDER_SELECT_COUNTRY')}
                               label={t('COUNTRY')}
                />
              </Col>
              <Col xs={6}>
                <Input value={this.getCustomerValue('city')} label={t('CITY')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('city')}
                       message={this.state.errors.city ? this.state.errors.city : ''}
                       onChange={(event) => this.updateCustomer('city', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={6}>
                <Input value={this.getCustomerValue('state')} label={t('STATE')}
                       valid={!this.state.errors.hasOwnProperty('state')}
                       message={this.state.errors.state ? this.state.errors.state : ''}
                       onChange={(event) => this.updateCustomer('state', event.target.value)}
                       round={true}
                />
              </Col>
              <Col xs={6}>
                <Input value={this.getCustomerValue('zip')} label={t('ZIP')}
                       required={true}
                       valid={!this.state.errors.hasOwnProperty('zip')}
                       message={this.state.errors.zip ? this.state.errors.zip : ''}
                       onChange={(event) => this.updateCustomer('zip', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={6}>
                <Input value={this.getCustomerValue('url')} label={t('URL')}
                       valid={!this.state.errors.hasOwnProperty('url')}
                       message={this.state.errors.url ? this.state.errors.url : ''}
                       onChange={(event) => this.updateCustomer('url', event.target.value)}
                       round={true}
                />
              </Col>
              <Col xs={6}>
                <Input value={this.getCustomerValue('fax')} label={t('FAX')}
                       valid={!this.state.errors.hasOwnProperty('fax')}
                       message={this.state.errors.fax ? this.state.errors.fax : ''}
                       onChange={(event) => this.updateCustomer('fax', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
          </div>
          <div className={'container-part'}>
            <Row className={'container-row'}>
              <Col xs={12}>
                <Input value={this.getCustomerValue('vatId')}
                       label={t('VAT_ID') + ' (' + t('FOR_EUROPEAN_CLIENTS_ONLY') + ')'}
                       required={this.selectedCountryIsEuMemberButNotDE()}
                       valid={!this.state.errors.hasOwnProperty('vatId')}
                       message={this.state.errors.vatId ? this.state.errors.vatId : ''}
                       onChange={(event) => this.updateCustomer('vatId', event.target.value)}
                       round={true}
                />
              </Col>
            </Row>
            <Row className={'container-row'}>
              <Col xs={6}>
                {this.props.winlineId &&
                  <WinlineId value={this.getCustomerValue('winlineId')} customerId={this.props.customer.id}
                             onChange={(value) => this.updateCustomer('winlineId', value)}
                             round={true}
                  />
                }
              </Col>
            </Row>
          </div>
          <div className={'container-part customer-edit-action-buttons'}>
            <Row className={'container-row'}>
              {this.props.onCancel ?
                <Col xs={12} sm={6}>
                  <Button
                    align={'right'}
                    classNames={'Button-CTA Button-Rounded-Side submit-button'}
                    onClick={this.props.onCancel}>{this.props.cancelLabel}
                  </Button>
                </Col> : <Col xs={12} sm={6}/>
              }
              <Col xs={12} sm={6}>
                <Button
                  align={'right'}
                  classNames={'Button-CTA Button-Rounded-Side submit-button'}
                  type={'submit'}>{this.props.saveLabel}
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </form>
    )
  }
}

CustomerEdit.defaultProps = {
  winlineId: false,
  prefill: false,
  cancelLabel: 'Cancel',
  isAdminUI: false
}

CustomerEdit.propTypes = {
  customer: PropTypes.any,
  cart: PropTypes.any.isRequired,
  onSave: PropTypes.func.isRequired,
  saveLabel: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string,
  winlineId: PropTypes.bool,
  prefill: PropTypes.bool,
  isAdminUI: PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    salesToken: state.salesToken
  }
}

const mapDispatchToProps = {
  setToken: setToken
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CustomerEdit))
